module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_7005.aeea5e15.png";